import { render, staticRenderFns } from "./GetAddr.vue?vue&type=template&id=1a89fdea&"
import script from "./GetAddr.vue?vue&type=script&lang=js&"
export * from "./GetAddr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports